// extracted by mini-css-extract-plugin
module.exports = {"styles":"_2C0qV4jQUpKSxjQnzJ_7du"};